export default "__VITE_ASSET__CDO7Zra___"